import React, { useContext, useEffect, useState } from "react";
import { images } from "../../Assets/images";
import { GlobalContext } from "../../Context/GlobalContext";
import { useLocation } from "react-router-dom";
import { urls } from "../../Url";
import storage from "../../Assets/js/Global";
import axios from "axios";
import Loader from "../../Components/Loader";

const UploadDocument = () => {
  const { documentData, setDocumentData, uploadDocument, translatedLabels } =
    useContext(GlobalContext);
  const location = useLocation();
  const screenLabels = translatedLabels?.common;
  const preselectedCategory = location.state?.selectedCategory || "";
  const editFile = location?.state?.file;

  const [isLoading, setIsLoading] = useState(false);

  const categories = [
    { id: 1, key: "id", name: screenLabels?.id?.label_value || "ID" },
    {
      id: 2,
      key: "healthcare",
      name: screenLabels?.healthcare?.label_value || "Healthcare",
    },
    {
      id: 3,
      key: "insurance",
      name: screenLabels?.insurance?.label_value || "Insurance",
    },
    {
      id: 4,
      key: "benefits",
      name: screenLabels?.benefits?.label_value || "Benefits",
    },
    {
      id: 5,
      key: "travel",
      name: screenLabels?.travel?.label_value || "Travel",
    },
    {
      id: 6,
      key: "education",
      name: screenLabels?.education?.label_value || "Education",
    },
  ];

  const handleFileChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (!uploadedFile) return;

    const maxSizeInMB = 10;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    if (uploadedFile.size > maxSizeInBytes) {
      window.showToast(
        "error",
        `File size exceeds ${maxSizeInMB}MB. Please choose a smaller file.`
      );
      return;
    }

    if (uploadedFile.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setDocumentData((prev) => ({
          ...prev,
          file: uploadedFile,
          previewUrl: reader.result,
        }));
      };
      reader.readAsDataURL(uploadedFile);
    } else if (uploadedFile.type === "application/pdf") {
      setDocumentData((prev) => ({
        ...prev,
        file: uploadedFile,
        previewUrl: images.pdfIcon,
      }));
    } else {
      setDocumentData((prev) => ({
        ...prev,
        file: uploadedFile,
        previewUrl: "",
      }));
    }
  };

  const handleCategoryChange = (e) => {
    setDocumentData((prev) => ({
      ...prev,
      selectedCategory: e.target.value,
    }));
  };
  useEffect(() => {
    if (preselectedCategory) {
      setDocumentData((prev) => ({
        ...prev,
        selectedCategory: preselectedCategory,
      }));
    }
  }, [preselectedCategory, setDocumentData]);

  useEffect(() => {
    if (editFile?.id) {
      setDocumentData((prev) => ({
        ...prev,
        selectedCategory: editFile.key,
        documentID: editFile?.id,
      }));
      storage.set("documentUpdate", true);
    } else {
      storage.remove("documentUpdate");
      setDocumentData({
        file: null,
        previewUrl: "",
        selectedCategory: preselectedCategory || "",
        documentID: null,
      });
    }
  }, [editFile?.id, editFile?.key, preselectedCategory, setDocumentData]);

  useEffect(() => {
    let objectUrl = null;
    const fetchPreviewUrl = async () => {
      if (!editFile?.id) {
        setDocumentData({
          file: null,
          previewUrl: "",
          selectedCategory: preselectedCategory || "",
        });
      }
      setIsLoading(true);

      try {
        const loginObject = storage.get("loginObj") || {};
        const freshToken = storage.get("accessToken");
        const payload = {
          deviceID: loginObject.deviceID,
          role: 3,
          userKey: loginObject.userKey,
          companyKey: loginObject.companyKey,
          adminKey: "",
          document_id: editFile?.id,
        };

        const res = await axios.post(urls.previewDocument, payload, {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${freshToken}`,
          },
        });

        const blob = new Blob([res.data], {
          type: res.headers["content-type"],
        });
        const contentType = res.headers["content-type"];
        const originalName = editFile?.fileName || "document";

        const file = new File([res.data], originalName, { type: contentType });
        let previewUrlValue;
        if (blob.type === "application/pdf") {
          previewUrlValue = images.pdfIcon;
        } else {
          objectUrl = URL.createObjectURL(blob);
          previewUrlValue = objectUrl;
        }

        setDocumentData((prev) => ({
          ...prev,
          file,
          previewUrl: previewUrlValue,
          selectedCategory: editFile?.key || prev.selectedCategory,
        }));
      } catch (err) {
        console.error("Preview error:", err);
      } finally {
        setIsLoading(false);
      }
    };

    if (editFile?.id) {
      fetchPreviewUrl();
    }

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [editFile?.id, editFile?.key, preselectedCategory, setDocumentData]);

  if (isLoading) {
    return (
      <div
        className="content-part d-flex justify-content-center align-items-center"
        style={{ height: "200px" }}
      >
        <Loader className="animate-spin" size={40} />
      </div>
    );
  }
  return (
    <div className="content-part">
      <label className="form-label">
        {screenLabels?.select_category?.label_value || "Select Category"}{" "}
        <span className="text-danger">*</span>
      </label>
      <select
        className="form-select mb-3"
        value={documentData.selectedCategory}
        onChange={handleCategoryChange}
      >
        <option value="">
          {screenLabels?.select_category?.label_value || "Select Category"}
        </option>
        {categories.map((cat) => (
          <option key={cat.id} value={cat.key}>
            {cat.name}
          </option>
        ))}
      </select>

      <label className="form-label">
        {screenLabels?.upload_docs?.label_value || "Upload document"}{" "}
        <span className="text-danger">*</span>
      </label>
      <div className="upload-box-container position-relative mb-3 p-2">
        <label htmlFor="upload-input" className="upload-overlay"></label>
        <input
          type="file"
          accept=".jpg,.jpeg,.png,.gif,.bmp,.pdf"
          onChange={handleFileChange}
          id="upload-input"
          className="upload-input"
        />
        <div className="upload-preview">
          {documentData.previewUrl ? (
            <img
              src={documentData.previewUrl}
              alt="preview"
              className="preview-img"
            />
          ) : documentData.file ? (
            `Selected: ${documentData.file.name}`
          ) : (
            <div>
              <img
                src={images.uploadIcon}
                alt="upload-icon"
                className="text-primary"
                width="60"
              />
              <p className="mb-0 text-muted">
                {screenLabels?.click_here_to_docs?.label_value ||
                  "Click here to choose a document to upload"}
              </p>
            </div>
          )}
        </div>
      </div>

      <div className="text-center">
        <button
          type="button"
          className="btn btn-primary"
          onClick={uploadDocument}
        >
          {editFile
            ? screenLabels?.update?.label_value || "Update"
            : screenLabels?.upload?.label_value || "Upload"}
        </button>
      </div>
    </div>
  );
};

export default UploadDocument;
